import React, { useContext, useEffect, useState } from 'react';
import dateFormat from "dateformat";
import { Link, useParams } from 'react-router-dom';
import { AuthContext } from '../../../Contexts/AuthContext/AuthProvider';
import { RotatingSquare } from 'react-loader-spinner';
const StaffDetails = () => {
    const { authUser } = useContext(AuthContext);
    // view data  
    const { id } = useParams();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        if (id) {
            fetch(`https://api.velormall.com/api/admin/view/${id}`, {
                method: 'GET',
            })
                .then((res) => res.json())
                .then((data) => {
                    setData(data.data);
                    setLoading(false);
                })
        }

    }, [id])

    return (
        <>
            <div class="d-flex mb-30 flex-wrap gap-3 justify-content-between align-items-center">
                <h6 class="page-title">{data?.name} is {data?.role === "super_admin" ? " Super Admin" : " "} {data?.role === "admin" ? " Admin" : " "} {data?.role === "staff" ? "Staff" : " "} </h6>
                <div class="d-flex flex-wrap justify-content-end gap-2 align-items-center breadcrumb-plugins">
                </div>
            </div>

            <div class="row mb-none-30 justify-content-center">
                <div class="col-xl-8 col-md-12 mb-30">
                    <div class="card b-radius--10 overflow-hidden box--shadow1">
                        <div class="card-body">
                            <h5 class="mb-20 text-muted">Details</h5>
                            <ul class="list-group">

                                <li class="list-group-item d-flex justify-content-between align-items-center">
                                    Name
                                    <span class="fw-bold"> {data?.name}</span>
                                </li>
                                <li class="list-group-item d-flex justify-content-between align-items-center">
                                    Email
                                    <span class="fw-bold"> {data?.email}</span>
                                </li>
                                <li class="list-group-item d-flex justify-content-between align-items-center">
                                    Phone
                                    <span class="fw-bold">{data?.phone}</span>
                                </li>

                                <li class="list-group-item d-flex justify-content-between align-items-center">
                                    Role
                                    <span class="fw-bold">{data?.role}</span>
                                </li>

                                <li class="list-group-item d-flex justify-content-between align-items-center">
                                    Date
                                    <span class="fw-bold">{dateFormat(data.createdAt, "d-m-yyyy h:MM:ss TT")}</span>
                                </li>

                                <li class="list-group-item d-flex justify-content-between align-items-center">
                                    Status

                                    {data.status ?
                                        <span class="badge badge--success text-success">Active</span>
                                        : <span class="badge badge--warning text-warning">Inactive</span>}

                                </li>
                            </ul>
                            <div className="form-group text-center pt-3">
                                <Link to={`/admin/staff/login/info/${data?._id}`} className="btn btn-primary   me-3">Login info</Link>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    );


};

export default StaffDetails;